// src/utils/statusUtils.js

// Utility function for human-readable status labels
export const getStatusLabel = (status) => {
    const statusLabels = {
        'pending': 'Aguardando',
        'confirmed': 'Confirmado (Aguardando Envio)',
        'delivered': 'Enviado (Aguardando Recebimento)',
        'completed': 'Concluído',
        'entregue': 'Entregue',
        'cancelled': 'Cancelado',
        'disputed': 'Em disputa',
        'em_troca': 'Em troca',
        'bloqueado_limite': 'Guardado (limite diário de anúncios)',
        'bloqueado_moderacao': 'Em análise (fotos)',
        'exchanged': 'Trocado',
        'available': 'Disponível',
        'completed_by_admin_decision': 'Concluído via sistema',
        'cancelled_by_admin': 'Cancelado via sistema',
        'Analisando': 'Analisando'
    };
    return statusLabels[status] || status;
};
